import type { GenericLanguages } from '@payloadcms/translations'

export const i18n: Partial<GenericLanguages> = {
  ar: {
    label: 'تحميل',
  },
  az: {
    label: 'Yükləyin',
  },
  bg: {
    label: 'Качване',
  },
  cs: {
    label: 'Nahrát',
  },
  da: {
    label: 'Upload',
  },
  de: {
    label: 'Datei',
  },
  en: {
    label: 'Upload',
  },
  es: {
    label: 'Subir',
  },
  et: {
    label: 'Lae üles',
  },
  fa: {
    label: 'بارگذاری',
  },
  fr: {
    label: 'Télécharger',
  },
  he: {
    label: 'העלה',
  },
  hr: {
    label: 'Prenesi',
  },
  hu: {
    label: 'Feltöltés',
  },
  is: {
    label: 'Hlaða upp',
  },
  it: {
    label: 'Carica',
  },
  ja: {
    label: 'アップロード',
  },
  ko: {
    label: '업로드',
  },
  my: {
    label: 'တင်ပြီး',
  },
  nb: {
    label: 'Last opp',
  },
  nl: {
    label: 'Uploaden',
  },
  pl: {
    label: 'Prześlij',
  },
  pt: {
    label: 'Carregar',
  },
  ro: {
    label: 'Încarcă',
  },
  rs: {
    label: 'Отпреми',
  },
  'rs-latin': {
    label: 'Otpremi',
  },
  ru: {
    label: 'Загрузить',
  },
  sk: {
    label: 'Nahrať',
  },
  sl: {
    label: 'Naloži',
  },
  sv: {
    label: 'Ladda upp',
  },
  ta: {
    label: 'பதிவேற்றம்',
  },
  th: {
    label: 'อัปโหลด',
  },
  tr: {
    label: 'Yükle',
  },
  uk: {
    label: 'Завантажити',
  },
  vi: {
    label: 'Tải lên',
  },
  zh: {
    label: '上传',
  },
  'zh-TW': {
    label: '上傳',
  },
}
